import React, { useRef } from 'react';

import { css, cx } from '@headout/pixie/css';

import useCaptureClickOutside from 'Hooks/useCaptureClickOutside';

import { strings } from 'Constants/strings';

import CurrencyPicker from './currencyPickerList';
import LanguageSelectorList from './languagePickerList';

const container = css({
	width: '57.75rem',
	maxHeight: '27rem',
	padding: '1.25rem',
	display: 'grid',
	gridTemplateColumns: '140px 1fr',
	backgroundColor: 'semantic.surface.light.white',
});

const pickerContainer = css({
	position: 'relative',
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'flex-start',
	alignItems: 'stretch',
	height: '100%',
	gap: '4px',
	maxHeight: '100%',
	overflowY: 'auto',

	'&.first-col': {
		paddingRight: '1.5rem',
	},

	'&.first-col::after': {
		content: '""',
		position: 'absolute',
		top: 0,
		bottom: 0,
		right: 0,
		borderRight: '1px solid',
		borderRightColor: 'semantic.dividers.dark',
	},

	'&.second-col': {
		paddingLeft: '1.5rem',
		overflowY: 'scroll',

		'&::-webkit-scrollbar': {
			width: '4px',
		},

		'&::-webkit-scrollbar-track': {
			backgroundColor: 'transparent',
		},

		'&::-webkit-scrollbar-thumb': {
			backgroundColor: 'semantic.dividers.dark',
			borderRadius: '8px',
		},
	},
});

const heading = css({
	position: 'sticky',
	top: 0,
	padding: '0 0 6px 8px',
	width: '100%',
	backgroundColor: 'semantic.surface.light.white',
	textStyle: 'Semantics/UI Label/Large (Heavy)',
});

const LanguageCurrencyPicker = ({
	onCloseModal,
	paramLang,
	languageCode,
	location,
	currencyCode,
}: any) => {
	const pickerRef = useRef(null);
	useCaptureClickOutside(pickerRef, onCloseModal);
	return (
		<div ref={pickerRef} className={container}>
			<div
				className={cx(
					pickerContainer,
					'first-col',
					'languageCurrencyPicker',
				)}
			>
				<h3 className={heading}>{strings.LANGUAGE}</h3>
				<LanguageSelectorList
					location={location}
					paramLang={paramLang}
					languageCode={languageCode}
					onAfterLanguageSelect={onCloseModal}
				/>
			</div>
			<div
				className={cx(
					pickerContainer,
					'second-col',
					'languageCurrencyPicker',
				)}
			>
				<CurrencyPicker
					location={location}
					paramLang={paramLang}
					currencyCode={currencyCode}
					onChange={onCloseModal}
				/>
			</div>
		</div>
	);
};

export default LanguageCurrencyPicker;
